/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import permissions from '../../../common/constants/permissions';

import './account/account.tpl.html';
import './api.tpl.html';
import './history/history.js';
import './limit/limit.tpl.html';
import './usage/usage.tpl.html';

/**
 * admin.api module used for the api view.
 */
angular
  .module('admin.api', [
    'admin.api.history',
    'ngCookies',
    // including this allows html in the data bound scope properties.
    'ngSanitize',
    'services.permissions'
  ])
  .constant('API_VIEWS', {
    ACCOUNT: 'account',
    HISTORY: 'history',
    LIMIT: 'limit',
    USAGE: 'usage'
  })
  .controller(
    'AdminAPICtrl',
    function (
      $scope,
      $filter,
      authFactory,
      httpApi,
      httpAccount,
      permissionService,
      API_VIEWS,
      ALERT_EVENTS,
      API_TYPES,
      VIEW_STATES
    ) {
      // Strings
      $scope.accountStr = $filter('i18n')('ACCOUNT');
      $scope.limitStr = $filter('i18n')('LIMIT');

      const config = ($scope.config = $scope.config || {});
      config.api = config.api || API_TYPES.REST_API;
      $scope.API_VIEWS = API_VIEWS;
      $scope.apiView = API_VIEWS.USAGE;
      $scope.backupUserId = '';
      $scope.backupUserName = '';
      $scope.isExternalUser = false;
      authFactory.getSignedRequest().then(function (userInfo) {
        $scope.loggedInUser = userInfo.context.user.userId;
        $scope.loggedInUserName = userInfo.context.user.username;
        $scope.isExternalUser = userInfo.loginType.scope === 'EXTERNAL';
      });

      $scope.apiMaxMsg =
        config.api === API_TYPES.BULK_API ? $filter('i18n')('BULK_API_MAX_MSG') : $filter('i18n')('API_MAX_MSG');

      // used to hide some elements in chatter
      authFactory.displayedInChatter().then(function (displayedInChatter) {
        $scope.isChatter = displayedInChatter;
      });

      // value to track the used api calls
      $scope.used = 0;
      // value to track the api limit
      $scope.limit = 0;
      // value to track the current server api limit
      $scope.serverLimit = 0;
      // Value used for message in the API.
      $scope.successMsg = '';

      /**
       * Function used to load the api count data from the httpApi service.
       */
      function loadApiCountData() {
        // If org is expired, dont get ApiUsage
        return permissionService.hasPermission(permissions.API_USAGE).then((hasPermission) => {
          if (!$scope.$parent.isExpiredOrg && hasPermission) {
            return httpApi.getApiUsage(config.api).then(
              function (apiObj) {
                $scope.used = apiObj.count;
                $scope.limit = apiObj.limit;
                $scope.serverLimit = apiObj.limit;
              },
              function () {
                $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('LOAD_API_USAGE_FAILED'));
              }
            );
          }
        });
      }

      /**
       * Function used to load the user that is currently being used to backup data.
       */
      function loadBackupUser() {
        httpAccount.getBackupUser().then(
          function (backupUserObj) {
            $scope.backupUserId = backupUserObj.backupUserId;
            $scope.backupUserName = backupUserObj.backupUserName;
          },
          function () {
            $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('LOAD_BACKUP_USER_FAILED'));
          }
        );
      }

      /**
       * Show the passed view.
       * @param {string} view The view.  Must be one of the api views defined in the apiViews array.
       */
      $scope.showView = function (view) {
        //Allow to change view if state is main (not started or expired) or when state is start and next view is
        //limit or account
        if (!(
          config.state === VIEW_STATES.ADMIN_HOME ||
          (config.state === VIEW_STATES.ADMIN_START && (view === API_VIEWS.LIMIT || view === API_VIEWS.ACCOUNT))
        )) {
          return;
        }

        // reset the success message for all api views but usage.
        if (view !== API_VIEWS.USAGE) {
          $scope.successMsg = '';
        }

        $scope.lastView = $scope.apiView;
        $scope.apiView = view;
      };

      /**
       * Handler for the request to change the api limit.
       */
      $scope.changeAPILimit = function () {
        // A little paranoia check
        $scope.serverLimit = parseInt($scope.serverLimit, 10);
        if (angular.isNumber($scope.serverLimit)) {
          httpApi.updateLimit($scope.serverLimit, config.api).then(function () {
            $scope.limit = $scope.serverLimit;
            $scope.successMsg = $filter('i18n')('USAGE_SUCCESS_TEMPLATE', [
              $filter('i18n')('API_LIMIT_MSG', [$filter('number')($scope.serverLimit)])
            ]);
            $scope.showView(API_VIEWS.USAGE);
          });
        } else {
          // If the user somehow gets by the validation just reset to the original value.
          $scope.serverLimit = $scope.limit;
        }
      };

      /**
       * Handler for the cancel button on the api limit view. It reset the serverLimit
       * and shows the usage view.
       */
      $scope.cancelApiLimit = function () {
        $scope.serverLimit = $scope.limit;
        $scope.showView($scope.lastView || API_VIEWS.USAGE);
      };

      /**
       * Handler for the request to change the api user. Authenticates the current user as the backup account via an
       * AJAX call (JWT bearer server-side); shows a success message on success or an error on failure.
       */
      $scope.changeAPIUser = function () {
        httpAccount.updateBackupUser().then(
          function () {
            $scope.successMsg = $filter('i18n')('USAGE_SUCCESS_TEMPLATE', [$filter('i18n')('API_CHANGE_MSG')]);
            loadBackupUser();
            $scope.showView(API_VIEWS.USAGE);
          },
          function (rejection) {
            const message =
              (rejection && rejection.data && rejection.data.message) || $filter('i18n')('ERROR_UPDATING_FORM');
            $scope.$emit(ALERT_EVENTS.ERROR.eventName, message);
          }
        );
      };

      loadApiCountData();
      loadBackupUser();

      // Anytime that the backup or export status goes to false refresh the apiCount
      $scope.$watch(
        function () {
          return $scope.backupInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.backupInProgress) {
            loadApiCountData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.exportInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.exportInProgress) {
            loadApiCountData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.bulkRestoreInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.bulkRestoreInProgress) {
            loadApiCountData();
          }
        }
      );
    }
  )
  .directive('adminApi', function () {
    return {
      templateUrl: 'admin/api/api.tpl.html',
      scope: {
        config: '=',
        serverLimit: '='
      },
      controller: 'AdminAPICtrl'
    };
  });
